module.exports = window.XMLHttpRequest;



//////////////////
// WEBPACK FOOTER
// ../node_modules/httpplease/lib/xhr-browser.js
// module id = 1455
// module chunks = 0